import { Dispatch } from 'redux';

import { requestHandler } from '../../../api';

export const expressGetFileStatusForDocuments = async (
  dispatch: Dispatch,
  companyRecieverId: string,
  documents: string[],
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/express/${companyRecieverId}/factoring/documents/fileStatus/add`,
    data: { documents },
    dispatch,
  });
  if (response) return response.data;
};

export const expressUploadFilesFromRequest = async (
  dispatch: Dispatch,
  companyRecieverId: string,
  data: FormData,
) => {
  const response = await requestHandler({
    method: 'patch',
    url: `internal/express/${companyRecieverId}/factoring/documents/file/upload`,
    data,
    headers: {},
    dispatch,
  });
  if (response) return response.data;
};

export const expresGetDocumentFile = async (
  dispatch: Dispatch,
  companyRecieverId: string,
  fileName: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/express/${companyRecieverId}/factoring/documents/file/${fileName}`,
    dispatch,
  });
  if (response) return response.data;
};

export const expressCheckDocumentsWithXML = async (
  dispatch: Dispatch,
  documentsIds: number[],
  clientId: string,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/express/${clientId}/factoring/request/cession/checkDocumentsWithXML`,
    data: { documentsIds },
    dispatch,
  });
  if (response) return response.data;
};

export const expressCheckDocumentCessionsStatus = async (
  dispatch: Dispatch,
  documentsIds: string[],
  clientId: string,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/express/${clientId}/factoring/request/cession/checkDocumentsCessionStatus`,
    data: { documentsIds },
    dispatch,
  });
  if (response) return response.data;
};
